import { FileLinks } from 'admin/documents/FileLinks';
import { PERIOD_TYPE_CHOICES } from 'admin/utils';
import { LifeInsuranceProduct } from 'generated/graphql';
import {
  ArrayField,
  BooleanField,
  Datagrid,
  DateField,
  FunctionField,
  ReferenceField,
  RichTextField,
  SelectField,
  Show,
  SingleFieldList,
  TabbedShowLayout,
  TextField,
} from 'react-admin';

import { PRODUCT_STATUS_CHOICES } from '../productUtils';

export const LifeInsuranceProductShow: React.FC = () => (
  <Show>
    <TabbedShowLayout>
      <TabbedShowLayout.Tab label="Základné info">
        <TextField label="ID" source="id" />
        <ReferenceField label="Klient" link="show" reference="Client" source="client.id">
          <TextField source="user.email" />
        </ReferenceField>
        <TextField label="Inštitúcia" source="institution.name" />
        <TextField label="Vlastná inštitúcia" source="institutionName" />
        <TextField label="Názov produktu" source="name" />
        <BooleanField label="Starostlivosť" source="enableFinancialAdvisorCare" />
        <ArrayField label="Dokumenty" source="documents">
          <SingleFieldList linkType={false}>
            <ArrayField source="files">
              <FileLinks />
            </ArrayField>
          </SingleFieldList>
        </ArrayField>
      </TabbedShowLayout.Tab>

      <TabbedShowLayout.Tab label="Zmluva">
        <TextField label="Číslo zmluvy" source="contractNumber" />
        <DateField label="Začiatok poistenia" locales="sk" source="contractSignDate" />
        <DateField label="Platnosť poistenia do" locales="sk" source="contractEndDate" />
      </TabbedShowLayout.Tab>

      <TabbedShowLayout.Tab label="Platby">
        <FunctionField
          label="Suma poistného"
          render={(record: LifeInsuranceProduct) =>
            record.paymentPeriod?.expectedAmount?.amount ? -record.paymentPeriod?.expectedAmount?.amount : undefined
          }
          source="paymentPeriod.expectedAmount.amount"
        />
        <TextField label="Opakovať každých" source="paymentPeriod.periodCount" />
        <SelectField choices={PERIOD_TYPE_CHOICES} label="" source="paymentPeriod.periodTypeCode" />
        <DateField label="Nasledujúca platba" locales="sk" source="paymentPeriod.expectedDate" />
      </TabbedShowLayout.Tab>

      <TabbedShowLayout.Tab label="Údaje pre platbu">
        <TextField label="Variabilný symbol" source="paymentInfo.variableSymbol" />
        <TextField label="Špecifický symbol" source="paymentInfo.specificSymbol" />
        <TextField label="Konštantný symbol" source="paymentInfo.constantSymbol" />
        <TextField label="IBAN" source="paymentInfo.ibanForPayment" />
      </TabbedShowLayout.Tab>

      <TabbedShowLayout.Tab label="Poistenci, poistníci a rozsah poistenia">
        <ArrayField label={false} source="applicants">
          <Datagrid bulkActionButtons={false}>
            <TextField label="Meno" source="name" />
            <TextField label="Priezvisko" source="surname" />
            <BooleanField label="Poistenec" source="isInsured" />
            <BooleanField label="Poistník" source="isInsuring" />

            <ArrayField label="Poistené riziká" source="insurance.insuranceRisks">
              <Datagrid bulkActionButtons={false}>
                <TextField label="Typ rizika" source="type" />
                <TextField label="Názov rizika" source="name" />
                <TextField label="Poistná suma" source="insuredSum.amount" />
                <TextField label="Poistné" source="annualCost.amount" />
              </Datagrid>
            </ArrayField>
          </Datagrid>
        </ArrayField>
      </TabbedShowLayout.Tab>

      <TabbedShowLayout.Tab label="Informácie o životnom poistení">
        <DateField label="platné k" source="financialDetailsUpdatedAt" />
        <TextField label="Výška odkupnej hodnoty" source="surrenderValue.amount" />
      </TabbedShowLayout.Tab>

      <TabbedShowLayout.Tab label="Sporiaca zložka">
        <TextField label="Sporiaca zložka" source="savings.amount.amount" />
        <TextField label="Poistná suma" source="savings.insuredSum.amount" />
      </TabbedShowLayout.Tab>

      <TabbedShowLayout.Tab label="Status">
        <SelectField choices={PRODUCT_STATUS_CHOICES} label="Status" source="status" />
        <DateField label="Zmena stavu" locales="sk" source="statusChangeDate" />
      </TabbedShowLayout.Tab>

      <TabbedShowLayout.Tab label="Poznámka">
        <RichTextField label="Poznámka" source="note" />
      </TabbedShowLayout.Tab>
    </TabbedShowLayout>
  </Show>
);
